module.exports = __webpack_public_path__ + "static/media/ford.e8c70dfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/OptIn/logos/ford.png
// module id = 879
// module chunks = 0